import type { TypedMyHotelGuestroom } from './-MyHotelGuestroom';
import RawMyHotelGuestroom from './MyHotelGuestroom.vue';
export * from './-MyHotelGuestroom';
export const MyHotelGuestroom = RawMyHotelGuestroom as typeof TypedMyHotelGuestroom;
